import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F4F4F0] pt-32 pb-24 flex items-center">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323]">
          Error · 404
        </div>
        <h1 className="mt-4 font-display text-6xl md:text-9xl tracking-tighter leading-[0.9] text-[#060913]">
          Page not on patrol.
        </h1>
        <p className="mt-6 text-lg text-[#5C5F66] max-w-lg">
          The page you were looking for isn't on our books. Try one of these instead.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/" className="border border-[#060913] px-5 py-3 font-mono text-[11px] tracking-[0.22em] uppercase hover:bg-[#D92323] hover:text-white hover:border-[#D92323]">Home →</Link>
          <Link to="/services" className="border border-[#060913] px-5 py-3 font-mono text-[11px] tracking-[0.22em] uppercase hover:bg-[#D92323] hover:text-white hover:border-[#D92323]">All Services →</Link>
          <Link to="/cities" className="border border-[#060913] px-5 py-3 font-mono text-[11px] tracking-[0.22em] uppercase hover:bg-[#D92323] hover:text-white hover:border-[#D92323]">All Cities →</Link>
        </div>
      </div>
    </div>
  );
}
